var map = {
	"./HW_Logo_Auswertung.png": 2653,
	"./HW_Logo_Eingabe.png": 2654,
	"./HW_Logo_Hilfe.png": 2655,
	"./HW_Logo_Zusatztools.png": 2656,
	"./HW_Logo_Zusatztools_old.png": 2657,
	"./KU_Logo_Auswertung.png": 2658,
	"./KU_Logo_Eingabe.png": 2659,
	"./KU_Logo_Hilfe.png": 2660,
	"./KU_Logo_Zusatztools.png": 2661,
	"./KU_Logo_Zusatztools_old.png": 2662,
	"./Logo_Lux.png": 1224,
	"./Logo_Lux_CC.png": 1226,
	"./Logo_Lux_KA.png": 1228,
	"./SO_Logo_Auswertung.png": 1230,
	"./SO_Logo_Eingabe.png": 2663,
	"./SO_Logo_Hilfe.png": 2664,
	"./SO_Logo_Zusatztools.png": 2665,
	"./SO_Logo_Zusatztools_old.png": 2666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2652;